module.exports = __webpack_public_path__ + "static/media/android4.73c41968.jpg";